query OrganizationUsersList(
  $page: Int = 0
  $rowsPerPage: Int = 10
  $filter: OrganizationUsersFilterInput
) {
  organizationUsers(
    page: $page, 
    rowsPerPage: $rowsPerPage, 
    filter: $filter
  ) {
    nodes {
      id
      roles
      user {
        id
        email
        firstName
        lastName
        displayName
      }
      createdAt
    }
    count
  }
}

